import type { ApiMirrorRegistry, ApiMirrorRegistryStatus } from '@fabric-app/types/connections';
import { useMutationMirrorRegistryUpdate } from '@fabric-app/business/connections/mutations/useMutationMirrorRegistryUpdate';
import { MirrorStatus } from '@fabric/woody-client';
import { MIRROR_MESSAGE_MAP } from '../constants';
import { toast } from '@fabric-app/business/store/alerts';

type ReturnType =
  | { toggleResumePause: VoidFunction; status: ApiMirrorRegistryStatus }
  | { toggleResumePause: undefined; status: ApiMirrorRegistryStatus | undefined };

export const useMirrorRegistryToggleResumePause = (mirror?: ApiMirrorRegistry): ReturnType => {
  const mutationUpdateMirrorRegistry = useMutationMirrorRegistryUpdate();

  if (mirror && [MirrorStatus.PAUSED, MirrorStatus.ACTIVE].includes(mirror.status)) {
    return {
      toggleResumePause: () => {
        if (
          mirror.status === MirrorStatus.PAUSED &&
          mirror.message &&
          mirror.message in MIRROR_MESSAGE_MAP
        ) {
          toast({
            content: MIRROR_MESSAGE_MAP[mirror.message as keyof typeof MIRROR_MESSAGE_MAP],
            id: 'mirror-registry-toggle-resume-pause-error',
          });
          return;
        }

        mutationUpdateMirrorRegistry.mutate({
          mirrorRegistryId: mirror.id,
          status: mirror.status === MirrorStatus.ACTIVE ? MirrorStatus.PAUSED : MirrorStatus.ACTIVE,
        });
      },
      status: mirror.status,
    };
  }

  return {
    toggleResumePause: undefined,
    status: mirror?.status,
  };
};
